import React from "react";
import { InputSelect, useMediaQuery, breakpoints } from "@tvg/design-system";
import { Willpay } from "@tvg/ts-types/Race";
import { DropdownSection, DropdownContainer } from "./styled-components";
import { gtmOnSelectWillPaysOption } from "../../../utils/gtm/willPaysNProbables";
import { getSelectionListWillPays } from "./functions";
import DynamicSelector from "../DynamicSelectorPro";

type Props = {
  selectedWillPay: string;
  willPays: Willpay[];
  changeWillPay: (wp: string) => void;
  raceNumber?: string;
  trackName?: string;
};

const Dropdown = ({
  willPays,
  selectedWillPay,
  changeWillPay,
  raceNumber,
  trackName
}: Props) => {
  const isMobile = useMediaQuery(breakpoints.tablet.max.sm);

  const typeOfPicks = willPays.map((element, index: number) => ({
    label: `$${element.wagerAmount.toFixed(2)} ${element.type.name} Results ${
      element.legResults
        ? element.legResults
            .map((lr) => lr.winningBi)
            .join(",")
            .replace(/,/g, " | ")
        : ""
    } | *`,
    value: index
  }));

  const handleOnChangeWillPay = (wp: unknown) => {
    const gtmLabel = typeOfPicks[+(wp as string)]?.label?.replace(
      /(\r\n|\n|\r)/gm,
      ""
    );
    gtmOnSelectWillPaysOption({
      raceNumber: raceNumber || "",
      trackName: trackName || "",
      label: gtmLabel || ""
    });
    changeWillPay(wp as string);
  };

  return (
    <>
      {isMobile && (
        <DynamicSelector
          itemsList={getSelectionListWillPays(willPays)}
          onTabChange={handleOnChangeWillPay}
        />
      )}
      {!isMobile && (
        <DropdownSection data-qa-label="willPays-select-section">
          <DropdownContainer data-qa-label="willPays-select-container">
            <InputSelect
              qaLabel="willPays-select-input"
              selectList={typeOfPicks}
              selectedValue={selectedWillPay}
              onChange={handleOnChangeWillPay}
            />
          </DropdownContainer>
        </DropdownSection>
      )}
    </>
  );
};

export default Dropdown;
